export default {
  name: "Promotions",
  path: "/promotions",
  component: () => import("@/views/Promotions")
};
